export default {"src":"/_next/static/media/glow-vector.35795ee6.svg","height":1797,"width":2158,"blurWidth":0,"blurHeight":0};